export default Object.freeze({
    LOGO: require("../../public/img/logo-header.png"),
    LOGO_SMALL_HEADER: require("../../public/img/logo-small-header.png"),
    LOGO_BLUE: require("../../public/img/logo-blue.png"),
    CALCULATOR: require("../../public/img/calculator.svg"),
    NAVIGATION: require("../../public/img/navigation.svg"),
    GOOGLE: require("../../public/img/google-icon.svg"),
    FACEBOOK: require("../../public/img/facebook-icon.svg"),
    LOGO_LOGIN: require("../../public/img/logo-login.png"),
    PYRAMID: require("../../public/img/pyramid.svg"),
    PYRAMID_ONE: require("../../public/img/pyramid-one.svg"),
    PYRAMID_TWO: require("../../public/img/pyramid-two.svg"),
    PYRAMID_THREE: require("../../public/img/pyramid-three.svg"),
    PYRAMID_FOUR: require("../../public/img/pyramid-four.svg"),
    PYRAMID_FIVE: require("../../public/img/pyramid-five.svg"),
    GEAR: require("../../public/img/gear.svg"),
    PLAY_STORE: require("../../public/img/google-play-store.svg"),
    APPLE_LOGO: require("../../public/img/apple-logo.svg"),
    NO_RESULTS: require("../../public/img/no-results.png"),
    PRO: require("../../public/img/pro.png"),
    INTERACTIONS: require("../../public/img/interactions.svg"),
});
